var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoPaly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#0F0",
    strokeWidth: 3,
    cx: 32,
    cy: 32,
    r: 30.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.717 33.375l-17.648 10.86A1.358 1.358 0 0124 43.078v-21.72a1.358 1.358 0 012.069-1.157l17.648 10.86a1.358 1.358 0 010 2.308v.006z",
    fill: "#0F0",
    fillRule: "nonzero"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxjaXJjbGUgc3Ryb2tlPSIjMEYwIiBzdHJva2Utd2lkdGg9IjMiIGN4PSIzMiIgY3k9IjMyIiByPSIzMC41Ii8+CiAgICA8cGF0aCBkPSJNNDMuNzE3IDMzLjM3NWwtMTcuNjQ4IDEwLjg2QTEuMzU4IDEuMzU4IDAgMDEyNCA0My4wNzh2LTIxLjcyYTEuMzU4IDEuMzU4IDAgMDEyLjA2OS0xLjE1N2wxNy42NDggMTAuODZhMS4zNTggMS4zNTggMCAwMTAgMi4zMDh2LjAwNnoiIGZpbGw9IiMwRjAiIGZpbGwtcnVsZT0ibm9uemVybyIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgVideoPaly as ReactComponent };